export default __webpack_public_path__ + "static/media/hero.127a13a4.jpg";